'use client';
import { useEffect, useRef } from 'react';

// Dipende da GSAP + ScrollTrigger già registrati dal progetto (src/utils/gsap.js).
import { gsap, ScrollTrigger } from '@/utils/gsap';

/**
 * Barra sottile in alto che segue la % di scroll dell'intera pagina.
 * Fixed, sopra l'header. Colore = accent del tema attivo.
 * @param {{ className?: string }} props
 */
export function ScrollProgress({ className = '' }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ctx = gsap.context(() => {
      gsap.set(el, { scaleX: 0, transformOrigin: '0 50%' });
      gsap.to(el, {
        scaleX: 1,
        ease: 'none',
        scrollTrigger: { trigger: document.body, start: 'top top', end: 'bottom bottom', scrub: true },
      });
    });
    return () => ctx.revert();
  }, []);

  return (
    <div
      ref={ref}
      className={['fixed top-0 left-0 right-0 h-[2px] bg-theme-accent z-[60]', className].join(' ')}
      style={{ pointerEvents: 'none' }}
    />
  );
}
